import React from "react";
import { Button, Col, Form, Input, Row, Typography, Switch, Card } from "antd";
import { Content } from "antd/lib/layout/layout";
import { useDispatch, useSelector } from "react-redux";
import { signin } from "../../redux/sign-in/signinThunk";
import "./SignInPageStyle.css";

const SignIn = () => {
  const dispatch = useDispatch();
  const { Title } = Typography;
  const { isLoading, error, data } = useSelector((state) => state.signin);

  const onFinish = (data) => {
    dispatch(signin(data));
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Content className="signin">
      <Title className="mb-15 text-center">Se Connecter</Title>
      <Row justify="center" align="middle">
        <Col span={20} lg={12}>
          <Card className="signin-card">
            <Title className="font-regular text-muted" level={5}>
              Entrez votre email et mot de passe pour vous connecter
            </Title>
            <Form
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              layout="vertical"
              className="row-col"
            >
              <Form.Item
                className="username"
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Veuillez entrer votre email!",
                  },
                ]}
              >
                <Input
                  placeholder="Email"
                  name="email"
                  value={data.email}
                />
              </Form.Item>

              <Form.Item
                className="username"
                label="Mot de passe"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Veuillez entrer votre mot de passe!",
                  },
                ]}
              >
                <Input
                  placeholder="Mot de passe"
                  name="password"
                  type="password"
                  value={data.password}
                />
              </Form.Item>

              <Form.Item
                name="remember"
                className="aligin-center"
                valuePropName="checked"
              >
                <Switch defaultChecked  />
                Se souvenir de moi
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                  loading={isLoading}
                >
                  SE CONNECTER
                </Button>
              </Form.Item>

              {error && <p>{error}</p>}
            </Form>
          </Card>
        </Col>
      </Row>
    </Content>
  );
};

export default SignIn;
